export const avatar = {
  'with-initials': {
    display: 'grid',
    alignItems: 'center',
    height: ['60px', '90px'],
    width: ['60px', '90px'],
    borderRadius: '50%',
    bg: 'brand.500',
    textAlign: 'center',
    color: 'white',
    fontSize: ['1.25rem', '1.5rem'],
    fontWeight: "600",
  },
};
